import { render, staticRenderFns } from "./FormTextos.vue?vue&type=template&id=10f0c7fd&scoped=true"
import script from "./FormTextos.vue?vue&type=script&lang=js"
export * from "./FormTextos.vue?vue&type=script&lang=js"
import style0 from "./FormTextos.vue?vue&type=style&index=0&id=10f0c7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0c7fd",
  null
  
)

export default component.exports